export const buttonTextMap = {
    "SHOP NOW": "shop_now",
    "EXPLORE NOW": "explore_now"
};
